module.exports = __webpack_public_path__ + "static/media/example.a9cce8d8.gif";